import fetch from 'unfetch';
import QS from 'query-string';

const getHeaders = () => {
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cache: 'no-cache'
  };

  const currentUser = window.localStorage.getItem('user')
  ? JSON.parse(window.localStorage.getItem('user'))
  : null;
  if (currentUser) {
    headers['token'] = currentUser.token;
  }
  return headers;
};

const request = async (url, method, args) => {
  let options = {
    method,
    timeout: 15000,
    credentials: 'include',
    headers: getHeaders()
  };
  if (method === 'POST' && args) {
    options.body = JSON.stringify(args);
  }
  try {
    let response = await fetch(url, options);
    response = await response.json();
    return response;
  } catch (err) {
    if (!err.status) {
      err.status = 503;
    }
    return {
      success: false,
      payload: null,
      error: err
    };
  }
};

const apiCall = async (endpoint, { args = null, method = 'POST' } = {}) => {
  let url = process.env.REACT_APP_API_BASE + endpoint;
  if (method === 'GET' && args !== null) {
    let queryString = QS.stringify(args);
    if (queryString.length > 0) {
      url = url + '?' + queryString;
    }
  }
  try {
    let result = await request(url, method, args);
    return result;
  } catch (err) {
    return {
      success: false,
      payload: null,
      error: err
    };
  }
};

export default apiCall;
